import * as React from 'react';
import { Button, LinkButton, UIHeading2, UIText1 } from '@cian/ui-kit';
import * as styles from './NotFoundForLocation.css';

export interface INotFoundForLocationProps {
  url: string | undefined | null;
  openModal(): void;
}

export const NotFoundForLocation: React.VFC<INotFoundForLocationProps> = ({ url, openModal }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['image']} />
      <div>
        <UIHeading2>У нас ещё нет посёлков в этом месте</UIHeading2>
        <div className={styles['description']}>
          <UIText1>
            Посмотрите все варианты загородной недвижимости поблизости или добавьте посёлок, если вы застройщик или его
            владелец
          </UIText1>
        </div>
        <div className={styles['actions']}>
          {url && (
            <div className={styles['catalog-link']}>
              <LinkButton size="XS" href={url} aria-label="Посмотреть все объекты">
                Посмотреть все объекты
              </LinkButton>
            </div>
          )}
          <Button size="XS" theme="fill_secondary" aria-label="Добавить посёлок" onClick={openModal}>
            Добавить посёлок
          </Button>
        </div>
      </div>
    </div>
  );
};
